module.exports = __webpack_public_path__ + "static/logo-bc1946c3a06119770f3f1d95589ff077.svg";